module.exports = __webpack_public_path__ + "static/media/Restriction on cargo flights.e42b2a41.png";